visibleThumbs = 4 # number of product colour thumbs on display

makeAssoc = (array, key, single = false)->
    result = {}
    if not single
        for item in array
            field = item[key]
            if field of result
                result[field].push item
            else result[field] = [item]
    else result[item[key]] = item for item in array
    return result

getSizes = (variants)->
    sizes =
        XS:    false
        S:     false
        M:     false
        L:     false
        XL:    false
        '2XL': false
        '3XL': false

    for variant in variants
        sizes[variant.size] = true
    sizes

Vue.component 'ascolour-product',
    template: "#ascolour-product"
    props: ['product']

    data: ->
        sku:     @product.sku
        url:     "/ascolour/quote/#{@product.slug}"
        image2:  "#{imgUrl}/api/tiles/#{@product.image_2}"
        name:     @product.name
        price:    "&euro;#{(@product.price * 1.15 * 1.8 * .01).toFixed(2)}"
        excerpt:  @product.excerpt
        colours:  makeAssoc @product.Variants, 'colour_code'
        hasSizes: @product.cat not in ['aprons', 'bags', 'hats']

        thumbsShift: 0
        selected:    null

    computed:
        selectedVariants: -> @colours[@selected]

        image: -> # todo: some variants don't have images
            if not @selected
                return "#{imgUrl}/api/tiles/#{@product.image}"
            "#{imgUrl}/api/products/#{@selectedVariants[0].image}"

        sizes: ->
            return {} if not @selected
            getSizes @selectedVariants

        coloursNum: ->
            len = 0
            len++ for c of @colours
            len

        few: -> if @coloursNum <= visibleThumbs then 'few' else ''

        maxShift: -> Math.floor((@coloursNum - 1)/ visibleThumbs)

        thumbOffset: -> "-#{76 * visibleThumbs * @thumbsShift}px"

    methods:
        getSwatch: (variant)-> "#{imgUrl}/api/colours/#{variant.swatch}"

        colourAlt:   (code)-> "Product colour '#{code}'"

        shiftLeft:  -> @thumbsShift-- if @thumbsShift > 0
        shiftRight: ->
            if @thumbsShift < @maxShift then @thumbsShift++
            else @thumbsShift = 0

@makeGalleryApp = (products)-> new Vue
    el: "#app"
    data:
        products: products

@makeMenuApp =-> new Vue
    el: "#main-nav"
    data:
        mobile:   false
        expanded: ''

    methods:
        expand: (name)->
            if @expanded is name then @expanded = ''
            else @expanded = name




Vue.component 'wait-button',
    template: """
<button :disabled='disabled || wait'
      @click.prevent='$emit("click")'
      class='wait-button'
      :class="{wait: wait}">
    <slot></slot>
    <img class='spinner'
         alt="Wait spinner"
         src="/wp-content/themes/tshirtcompany/css/images/spinner-white.svg" />
</button>
"""
    props:
        wait:       Boolean
        disabled:   Boolean

Vue.component 'quote-tile',
    template: '#quote-tile'
    props: ['quote']

    computed:
        image: -> backgroundImage: "url('#{@quote.image}')"
        selected: -> @quote.vars.filter (v)-> v.num > 0

    methods:
        clear: -> v.num = 0 for v in @selected
        selectSize: (variant)-> variant.num = if variant.num > 0 then 0 else 1

minQuote = 25
@makeProductApp = (product)-> new Vue
    el: "#app"
    data:
        product: product
        name:    product.name
        sku:     product.sku
        excerpt: product.excerpt
        descr:   product.description.replace /\n/g, '<br>'
        price:    "&euro;#{(product.price * 1.15 * 1.8 * .01).toFixed(2)}"
        colours:  makeAssoc product.Variants, 'colour_code'
        hasSizes: product.cat not in ['aprons', 'bags', 'hats']

        selected: product.Variants[0].colour_code
        vars:     product.Variants

        printing:   false
        embroidery: false

        legPrint:   product.cat is 'pants' #leg print option
        sleeveless: product.type in ['bags', 'hats', 'pants']

        submitted:  false
        submitting: false
        failed:     false

        form:
            printColorsFront:           0
            printColorsBack:            0
            printColorsLeftSleeve:      0
            printColorsRightSleeve:     0
            printColorsLeftLeg:         0
            printColorsRightLeg:        0

            embroidFront:               false
            embroidBack:                false
            embroidLeftSleeve:          false
            embroidRightSleeve:         false
            embroidLeftLeg:             false
            embroidRightLeg:            false

            sku:            product.sku
            brand:          'AS Colour'
            productType:    product.cat
            productUrl:     window.location.href

            targetDate:     ''
            comments:       ''
            firstName:      ''
            email:          ''
            phone:          ''

            quantities:     ''
            quoteType:      'wearable'
            action:         'quote_forwarder'

    computed:
        colour: -> @colours[@selected]

        sizes: ->  makeAssoc @colour, 'size', true

        slideStyle: -> backgroundImage: "url('#{imgUrl}/api/products/#{@colour[0].image}')"

        quotes: ->
            quotes = []
            for code, vars of @colours
                for v in vars when v.num > 0
                    quotes.push
                        vars:   vars
                        colour: code
                        sizes:  makeAssoc vars, 'size', true
                        image: "#{imgUrl}/api/products/#{v.image}"
                    break
            quotes

        total: ->
            sum = 0
            sum += +v.num for v in @vars
            sum

        canFillout: -> @total >= minQuote

        remaining:  -> minQuote - @total

        serviceSpecified: ->
            f = @form
            prints = +f.printColorsFront + +f.printColorsBack + +f.printColorsLeftSleeve + +f.printColorsRightSleeve + +f.printColorsLeftLeg + +f.printColorsRightLeg
            return prints > 0 if @printing and not @embroidery

            embroid = f.embroidFront or f.embroidBack or f.embroidLeftSleeve or f.embroidRightSleeve or f.embroidLeftLeg or f.embroidRightLeg
            return embroid if @embroidery and not @printing

            prints > 0 and embroid

        contactDetailsSupplied: -> @form.firstName.trim() and @form.email.trim()

    methods:
        getSwatch: (variant)-> "#{imgUrl}/api/colours/#{variant.swatch}"

        colourAlt: (code)-> "Product colour '#{code}'"

        plural: (word, num)-> if num is 1 then word else word + 's'

        selectSize: (size)-> size.num = if size.num > 0 then 0 else 1

        getQuantities: ->
            colours = []
            for q in @quotes
                sizes = []
                for label, v of q.sizes when v.num > 0
                    sizes.push "#{label}:#{v.num}"
                colours.push "#{q.colour}: " + sizes.join "\t"
            "\n\t" + colours.join "\n\t"

        submit: ->
            @submitting = true
            ok    = => @submitted  = true
            done  = => @submitting = false
            notok = => @failed = true

            @form.quantities = do @getQuantities
            ajax @form, ok, notok, done

ajax = (data, success, error, completed)->
    url = '/wp-admin/admin-ajax.php'
    form = new FormData
    props = (prepend, val)->
        if typeof val isnt 'object'
            form.append prepend, val
        else for k,v of val
            props "#{prepend}[#{k}]", v
        form
    props k,v for k,v of data

    req = new XMLHttpRequest
    req.onreadystatechange =->
        if req.readyState == 4
            response = 'OK'
            if req.response and req.response isnt ''
                response = JSON.parse req.response
            if req.status isnt 200
                error response if error
            else
                console.log response
                success response if success
    req.onload = completed if completed
    req.open "POST", url
    req.send form
